// Advanced Filters Utils
export const parseNum = (s: string) => {
  if (!s) return null;
  const n = Number(String(s).replace(/[^\d]/g, ''));
  return Number.isFinite(n) ? n : null;
};

export const validatePair = (minStr: string, maxStr: string) => {
  const min = parseNum(minStr),
    max = parseNum(maxStr);
  if (min == null || max == null) return { minErr: '', maxErr: '' };
  return min > max
    ? {
        minErr: 'Enter a minimum that is less than or equal to the maximum.',
        maxErr: 'Enter a maximum that is greater than or equal to the minimum.',
      }
    : { minErr: '', maxErr: '' };
};

export const zeroOr = (s: string) => (s === '0' ? '' : s);

export const numbersOnly = (s: string) => s.replace(/\D+/g, '');

export const PAIRS = [
  { title: 'House Depth (feet)', min: 'MinDepth', max: 'MaxDepth' },
  { title: 'House Width (feet)', min: 'MinWidth', max: 'MaxWidth' },
] as const;
